import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 50 50' fill={fillColor} className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path d='m8,15c3.86,0 7,-3.14 7,-7s-3.14,-7 -7,-7s-7,3.14 -7,7s3.14,7 7,7zm0,-12c2.757,0 5,2.243 5,5s-2.243,5 -5,5s-5,-2.243 -5,-5s2.243,-5 5,-5z' />
        <rect y='7' x='18' width='31' height='2' />
        <path d='m8,32c3.86,0 7,-3.14 7,-7s-3.14,-7 -7,-7s-7,3.14 -7,7s3.14,7 7,7zm0,-12c2.757,0 5,2.243 5,5s-2.243,5 -5,5s-5,-2.243 -5,-5s2.243,-5 5,-5z' />
        <rect y='24' x='18' width='31' height='2' />
        <path d='m8,49c3.86,0 7,-3.14 7,-7s-3.14,-7 -7,-7s-7,3.14 -7,7s3.14,7 7,7zm0,-12c2.757,0 5,2.243 5,5s-2.243,5 -5,5s-5,-2.243 -5,-5s2.243,-5 5,-5z' />
        <rect y='41' x='18' width='31' height='2' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
